import React from 'react'
export default function MinimalRightIcon({ size = 24, width = size, height = size, fill, secondaryFill, stroke, secondaryStroke, children }) {
  return (<svg width={width} height={height} xmlns="http://www.w3.org/2000/svg"  viewBox="0 0 16 16">{children}
<g fill={fill} stroke={stroke} className="nc-icon-wrapper"><path d="m4.9 15.7-1.5-1.4L9.7 8 3.4 1.7 4.9.3 12.6 8z"/></g></svg>)
}
